const primeiroVisivel = (seletor) => {
    try {
        return [...document.querySelectorAll(seletor)].find((elemento) => elemento.getClientRects().length > 0) ?? null;
    } catch {
        return null;
    }
};

// Um mesmo seletor pode casar com versões desktop e mobile do mesmo elemento:
// vale a primeira que está de fato renderizada na tela. Uma lista de seletores
// é lida em ordem de prioridade (ex.: a primeira linha da tabela, senão a tabela)
export const encontrarElementoVisivel = (seletor) => {
    if (!seletor) return null;
    const seletores = Array.isArray(seletor) ? seletor : [seletor];
    for (const atual of seletores) {
        const elemento = primeiroVisivel(atual);
        if (elemento) return elemento;
    }
    return null;
};

// Resolve com o elemento assim que ele aparecer, ou `null` ao estourar o tempo limite.
// Cobre telas que só renderizam o alvo depois de carregar dados da API
export const aguardarElemento = (seletor, tempoLimite = 8000) => new Promise((resolve) => {
    const imediato = encontrarElementoVisivel(seletor);
    if (imediato) {
        resolve(imediato);
        return;
    }

    let limite = null;
    const observador = new MutationObserver(() => {
        const elemento = encontrarElementoVisivel(seletor);
        if (elemento) terminar(elemento);
    });

    const terminar = (elemento) => {
        observador.disconnect();
        clearTimeout(limite);
        resolve(elemento);
    };

    observador.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
    });
    limite = setTimeout(() => terminar(null), tempoLimite);
});
